import BarChart from '../../../../components/BarChart';
import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useUserAccumulatedVoSpool from '../../../../hooks/web3/vault/useUserAccumulatedVoSpool';
import useUserAvailableVotingPower from '../../../../hooks/web3/vault/useUserAvailableVotingPower';
import useUserStakedSpool from '../../../../hooks/web3/vault/useUserStakedSpool';

type Props = {
    isEmission?: boolean;
};

const AccumulatedVoSpool: React.FC<Props> = ({ isEmission = false }) => {
    const { userAvailableVotingPower } = useUserAvailableVotingPower();

    const { userAccumulatedVoSpool } = useUserAccumulatedVoSpool();

    const { userStakedSpool } = useUserStakedSpool();

    return (
        <Detail
            title={
                <>
                    <span>
                        Your Accumulated voSPOOL{' '}
                        {isEmission && 'at time of proposal creation'}
                    </span>
                    <InfoPopUp className='accumulated-vo-spool'>
                        <div>
                            Your voSPOOL is accumulated at a rate of 1/156 of your staked
                            $SPOOL per epoch, up to a maximum of 156 weekly epochs.
                        </div>

                        <div className='mt'>
                            Your voSPOOL = (# of Epochs since staking / 156 Epoch Maximum)
                            x (Your Staked $SPOOL)
                        </div>

                        <div className='mt'>
                            <span className='block'>1 Epoch = 1 Week</span>
                            Your Max voSPOOL = Your Staked $SPOOL. You can stake multiple
                            times, but each stake is calculated on its own 156 week
                            period. Your voSPOOL calculation restarts from 0 if you
                            unstake any $SPOOL.
                        </div>
                    </InfoPopUp>
                </>
            }
            value={
                <>
                    <div>
                        {isEmission
                            ? Math.floor(+(userAvailableVotingPower || 0))
                            : formatUSD(userAccumulatedVoSpool || 0)}
                        /
                        {isEmission
                            ? Math.round(parseInt(userStakedSpool || '0'))
                            : formatUSD(userStakedSpool || 0)}
                    </div>
                    <BarChart
                        value={
                            isEmission
                                ? userAvailableVotingPower || 0
                                : userAccumulatedVoSpool || 0
                        }
                        total={userStakedSpool || 0}
                    />
                </>
            }
        />
    );
};

export default AccumulatedVoSpool;
